module.exports = __webpack_public_path__ + "static/media/SocialMediaAd.fb17dd25.mp3";